import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints'
import LazyVideo from '@/components/landing/common/LazyVideo'

const StyledComp = styled.section`
  padding: 120px 40px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: ${breakpoints.medium}) {
    padding: 40px;
  }
  .grid-header {
    font-size: 36px;
    letter-spacing: -0.01em;
    margin: 0 0 32px;
  }

  .grid-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  @media (max-width: 900px) {
    .grid-row {
      grid-template-columns: 1fr;
    }
  }

  .card {
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .card-graphic {
    position: relative;
    height: 520px;
    display: flex;
    opacity:0.3;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    @media (max-width: ${breakpoints.medium}) {
      height: 300px;
    }
  }

  .card-body {
    padding: 20px 24px 28px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: #16151a;
    margin: 0 0 6px;
  }

  .card-subtitle {
    font-size: 14px;
    line-height: 1.45;
    color: #8a8a8e;
    margin: 0;
  }
`;

const EnterpriseGrid = () => {
  return (
    <StyledComp>
      <h2 className="grid-header serif">Commercial financial data SDKs with easy licensing for your products</h2>

<div className="grid-row">
  {/* Card 1: Summaries */}
  <div className="card">
    <div className="card-graphic">
      <LazyVideo src={'https://cdn.studio14a.com/axion/devshapes/expo.mp4'} />
    </div>
    <div className="card-body">
      <h3 className="card-title">Institutional-grade data, ready to ship</h3>
      <p className="card-subtitle">
        Clean, normalized filings, transcripts, and market events delivered through our financial data API, fully licensed for commercial use in your products, with clear, straightforward terms.
      </p>
    </div>
  </div>

  {/* Card 2: Be first */}
  <div className="card">
    <div className="card-graphic">
      <LazyVideo src={'https://cdn.studio14a.com/axion/devshapes/helix.mp4'} />
    </div>
    <div className="card-body">
      <h3 className="card-title">Licensed financial data across decades of history</h3>
      <p className="card-subtitle">
        Daily and hourly market data, earnings calls, transcripts, and global market updates, commercial licensing included, with decades of history available nearly instantly for quant research and products.
      </p>
    </div>
  </div>

  {/* Card 3: Never miss a mention */}
  <div className="card">
    <div className="card-graphic">
      <LazyVideo src={'https://cdn.studio14a.com/axion/devshapes/ball.mp4'} />
    </div>
    <div className="card-body">
      <h3 className="card-title">Signal detection, push alerts, full rights</h3>
      <p className="card-subtitle">
        Monitor entities, themes, and keywords across structured and unstructured financial data with instant alerts, licensed to integrate and redistribute outputs in your analytics and trading products.
      </p>
    </div>
  </div>
</div>
          </StyledComp>
  );
};

export default EnterpriseGrid;
